// Environment configuration
// Single source of truth for all worker URLs.
//
// At build time Vite inlines `import.meta.env.VITE_*` values from .env files
// or the deploy environment. These constants fall back to the production
// defaults when nothing is set, so existing builds keep working.

const env = (typeof import.meta !== 'undefined' && import.meta.env) || {}

export const API_URL =
  env.VITE_API_URL || 'https://clystcore-api.chris-c6d.workers.dev'

export const API_BASE = `${API_URL}/api`

export const PDF_WORKER_URL =
  env.VITE_PDF_WORKER_URL || 'https://clystcore-pdf.chris-c6d.workers.dev'

// Convenience flag — true in `vite dev`, false in `vite build` output.
export const IS_DEV = !!env.DEV
